import './Achievements.css'
import { motion } from 'framer-motion'
import { achievements } from '../config/achievements'
import { HiddenDevComment } from './DeveloperMode'
import { devComments } from '../config/devComments'
import { useDebug } from '../contexts/DebugContext'
import { getAnimProps } from '../utils/anim'

// Timeline layout: achievement cards alternate entrance from left/right (x: -50 or +50) based on index parity,
// with a subtle scale-up on hover.
// Even index cards come from left (-50px X), odd from right (+50px X). Creates a classic timeline
// alternating pattern. whileHover: { scale: 1.03 } gives a subtle hover pop effect.
// delay: index * 0.1 provides 100ms stagger between cards.
// viewport: { once: true } ensures animation plays only once (when section first scrolls into view).
const AchievementsTimeline = () => {
  const { config: debug } = useDebug()

  return (
    <section id="achievements" className="achievements">
      <div className="container">
        <motion.h2 {...getAnimProps('ACHIEVEMENTS', debug)}>
          Milestones & Impact
          <HiddenDevComment {...devComments.achievements} />
        </motion.h2>

        <div className="achievements-timeline">
          {achievements.map((item, index) => (
            /* Cards alternate entrance from left (even) or right (odd); slight hover scale for interactivity */
            <motion.div
              key={index}
              className="achievement-card glass-panel"
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              whileHover={{ scale: 1.03, transition: { duration: 0.2 } }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className={`achievement-icon ${item.type}`}>
                {item.icon}
              </div>
              <div className="achievement-content">
                <span className="achievement-date">{item.date}</span>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AchievementsTimeline
